import React from 'react'

const Loading = () => {
  return (
    <div className="loader">Loading...</div>
  )
}

export default Loading